export const useProfileData = {
  contactVisibility: {
    successToastOnMsg: `Contact Visibility has been turned on. The changes you made will take 24 hours to reflect.`,
    successToggleOffMsg: `Contact Visibility has been turned off. The changes you made will take 24 hours to reflect.`,
    toastErrorMsg: `A problem is encountered. The requested action cannot be completed.`,
    contactHeading: "Contact Visibility",
    contactContent:
      "Turn OFF to mask your contact details and make your profile confidential to recruiters.",
    contactNote: "Contact details within your resume remain visible.",
    contactToggleLabel: "Turn OFF Contact Visibility",
    infoPopUpMainHeadingMessage:
      "Are you sure you want to disable Contact Visibility?",
    infoPopUpMessages: [
      "Disabling this may cause you to miss potential job offers or networking opportunities due to hidden contact details.",
      "Recruiters may overlook your profile if contact information is not visible, reducing your chances of being contacted",
    ],
  },
  profileVisibility: {
    successToastOnMsg: "Profile Visibility has been turned on.",
    successToggleOffMsg: "Profile Visibility has been turned off.",
    toastErrorMsg: `A problem is encountered. The requested action cannot be completed.`,
    profileHeading: "Profile Visibility",
    infoPopUpMainHeadingMessage:
      "Are you sure you want to disable Profile Visibility?",
    infoPopUpMessages: [
      "This will remove your profile from recruiter searches, reducing your exposure to new opportunities.",
      "Recruiters will no longer see your profile, which may result in missed connections and job prospects.",
    ],
    profileContent:
      "Turn OFF to restrict your profile visibility in recruiter searches. However, your profile remains accessible to recruiters for jobs you apply for.",
    secondaryBtnLabel: "Keep Profile Visibility",
  },
  profileAutoUpdate: {
    successToastOnMsg: "Profile Auto Update has been turned on.",
    toastErrorMsg: `A problem is encountered. The requested action cannot be completed.`,
    profileHeading: "Profile Auto Update",
    profileContent:
      "Profile Auto Update syncs your foundit profile with the latest information from your public profiles.",
    infoPopUpMainHeadingMessage:
      "Are you sure you want to disable Profile Auto Update?",
    disabledSuccessMsg: [
      "Auto-Update disabled.",
      "Your profile has reverted back to pre-update state.",
    ],
    reasons: [
      {
        value: "INACCURATE_PROFILE_INFORMATION",
        id: "reason1",
        title: "Inaccurate profile information",
        description:
          "This action will deletes all the latest auto-updates and reverts your profile to it's pre-update state.",
      },
      {
        value: "OTHER_REASONS",
        id: "reason2",
        title: "Other reasons",
        description:
          "This action disables Auto-Apply for future updates. Existing information on your profile will be maintained.",
      },
    ],
  },
  blockCompany: {
    toastErrorMsg: `A problem is encountered. The requested action cannot be completed.`,
    staticData: {
      title: "Block Companies",
      description:
        "Use this feature to conceal your profile and resume from selected companies.",
      addButtonText: "Add Company to Block List",
    },
  },
};
